export default function Container({ children, className, style }) {
  return (
    <main
      className={` ${className ? className : ""}`}
      style={style ? style : {}}
    >
      {children}
    </main>
  )
}
